import PropTypes from 'prop-types';
import { useCallback, useEffect, useMemo, useState } from 'react';
//
import { QuickBookContext } from './quickbook-context';
import { getDatabase, ref, onValue, query } from "firebase/database";
import { useAuthContext } from 'src/auth/hooks';
import useFirebaseApp from 'src/hooks/use-firebase-app';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import { useCheckRTDbMutation } from 'src/services/quick-book-query';

export function QuickBookProvider({ children }) {
    const authContext = useAuthContext();
    const { firebaseApp } = useFirebaseApp();
    const database = getDatabase(firebaseApp);

    const [isNeedQuickBookLogin, setIsNeedQuickBookLogin] = useState(false);

    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if(authContext?.authenticated){
            console.log("Start to listen the quickbook notification");

            const notificationRef = query(ref(database, 'notifications/quickbooks'));

            onValue(notificationRef, (snapshot) => {
                console.log(snapshot);

                if(snapshot.exists()){
                    console.log("Received new quickbook notification");

                    snapshot.forEach((notification) => {
                        if(notification.key === 'isLoginRequired'){
                            console.log(notification.val());
                            setIsNeedQuickBookLogin(notification.val());
                        }
                    });
                }
                else {
                    console.log("Received new quickbook notification snapshot not exist");
                }
            }, (error) => {
                console.error("Error receiving quickbook notification");
                console.error(error);
            });
        }
    }, [authContext]);

    const [
        checkRTDb,
        {
            isLoading: isLoadingCheckRTDb,
            isSuccess: isSuccessCheckRTDb,
            data: rTDbData,
            isError: isErrorCheckRTDb,
            error: errorCheckRTDb
        }
    ] = useCheckRTDbMutation();

    const checkRTDbConnection = useCallback(async () => {
        await checkRTDb();
    }, []);

    useEffect(() => {
        if(isSuccessCheckRTDb && rTDbData){
            console.log(rTDbData);

            if(rTDbData.data){
                window.open(rTDbData.data.authUrl, "_blank");
            }
        }
        else if(isErrorCheckRTDb && errorCheckRTDb){
            enqueueSnackbar(errorCheckRTDb.data?.error?.message, {variant: 'error'});
        }
    }, [isSuccessCheckRTDb, rTDbData, isErrorCheckRTDb, errorCheckRTDb]);

    const memoizedValue = useMemo(
        () => ({
            
        }),
        []
    );

    return <QuickBookContext.Provider value={memoizedValue}>
        {children}

        <Dialog
            open={isNeedQuickBookLogin}
            onClose={() => {}}
            aria-labelledby="responsive-dialog-title"
        >
            <DialogTitle id="responsive-dialog-title">
                Quick Book
            </DialogTitle>
            
            <DialogContent>
                <DialogContentText>
                    Your Quick Book session has been expired. Please login and continue for an uninterrupted service
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <LoadingButton 
                    onClick={checkRTDbConnection} 
                    loading={isLoadingCheckRTDb}
                >
                    Login
                </LoadingButton>
            </DialogActions>
        </Dialog>
    </QuickBookContext.Provider>;
}

QuickBookProvider.propTypes = {
  children: PropTypes.node,
};